import { ReadableSpan, SpanExporter } from '@opentelemetry/sdk-trace-node';
import { ExportResult, ExportResultCode } from '@opentelemetry/core';
import { Attributes, SpanKind } from '@opentelemetry/api';

import { idGenerator } from '../utils/generateUUID';
import { hrTimeToNanosNumber } from '../utils/hrTimeToNanoNumber';
import { AppEnv, defaultResourceAttr, TraceDropToken, pointKillTag } from '../const';
import { convertAttributesToString } from '../utils/convertAllAttrIntoString';
import { processSnipConfig } from '../utils/getSnippingConfig';

export class CustomTraceExporter implements SpanExporter {
  private tracePrefix: string = "force-trace-prefix"
  private traceSuffix: string = "force-trace-suffix"

  export(spans: ReadableSpan[], resultCallback: (result: ExportResult) => void) {
    // 1. 过滤掉被点杀的特定 module 或带有 Drop 标记的 Span
    const finalSpans = spans.filter(span => {
      if ((span.attributes ?? {})[TraceDropToken]) return false;

      const pkTag = span.attributes?.[pointKillTag] as string;
      if (pkTag) {
        try {
          const snipingConfig = processSnipConfig(pkTag);
          if (snipingConfig?.traces?.modules?.includes("*")) {
            return false;
          }
          const module = span.attributes?.module as string;
          if (module && snipingConfig?.traces?.modules?.includes(module)) {
            return false;
          }
        } catch (e) {
          console.error(`Failed to parse in trace exporter:`, e);
        }
      }

      return true;
    });

    if (!finalSpans.length) {
      resultCallback({ code: ExportResultCode.SUCCESS });
      return;
    }

    const isDev = process.env.NODE_ENV === "development";
    const defaultAttributes: Attributes = {
      uuid: idGenerator.generateTraceId(),
      app_env: isDev ? AppEnv.Dev : AppEnv.Prod,
    };

    // 模拟 OTLP 的结构化过程
    const otlpLikeStructure = {
      resource: {
        attributes: {
          ...defaultResourceAttr
        }
      },
      spans: finalSpans.map(span => {
        const rawAttributes = {
          ...defaultAttributes,
          ...(span.attributes ?? {}),
        }

        // 将所有属性转换为字符串
        const attributes = convertAttributesToString(rawAttributes);

        return {
          startTimeUnixNano: hrTimeToNanosNumber(span.startTime),
          endTimeUnixNano: hrTimeToNanosNumber(span.endTime),
          name: span.name,
          attributes: attributes,
          traceID: span.spanContext().traceId,
          spanID: span.spanContext().spanId,
          parentSpanID: span.parentSpanContext?.spanId,
          status: span.status,
          kind: SpanKind.SERVER
        }
      })
    }

    console.log(this.tracePrefix + JSON.stringify(otlpLikeStructure) + this.traceSuffix);
    resultCallback({ code: ExportResultCode.SUCCESS });
  }

  async shutdown() { }
}
